<template>
  <div>
    <a-form class="mb-4" :form="form">
      <p>Select Class and Session</p>
      <div class="row mb-3">
        <div class="col-md-4">
          <a-select
            showSearch
            placeholder="Select Class"
            optionFilterProp="children"
            :filterOption="filterOption"
            @change="onClassSelect"
            :loading="selectLoading"
          >
            <a-select-option :value="undefined">
              None
            </a-select-option>
            <a-select-option v-for="schoolClass in schoolClasses" :value="schoolClass.id" :key="schoolClass.id">
              {{schoolClass.name}}
            </a-select-option>
          </a-select>
        </div>
        <div class="col-md-4">
          <a-select
            v-model="selectedSession"
            :defaultValue="currentSession ? currentSession.id : ''"
            @change="onSessionSelect"
            :loading="selectLoading"
          >
            <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
              {{schoolSession.name}}
              <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
            </a-select-option>
          </a-select>
        </div>
      </div>

      <a-spin :spinning="spinning" v-if="showForm">

        <a-divider />
        <p class="pt-3">Assign Class Fees</p>
        <div class="row mb-3">
          <div class="col-md-9 px-2">
            <table class="table table-borderless table-responsive-sm">
              <thead>
                <tr>
                  <th scope="col">Fee</th>
                  <th scope="col">Payment Type</th>
                  <th scope="col">Fee Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="feeType in classFeeTypes" :key="feeType.id">
                  <td>
                    <div>
                      <a-form-item class="d-none">
                        <a-input
                          placeholder="Name"
                          v-decorator="[`fees[${feeType.id}][fee_id]`, {initialValue: feeType.id}]"
                        />
                      </a-form-item>
                      <span class="px-2">{{ feeType.name }}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <a-form-item class="d-none">
                        <a-input
                          placeholder="Name"
                          v-decorator="[`fees[${feeType.id}][payment_type]`, {initialValue: feeType.type}]"
                        />
                      </a-form-item>
                      <span class="px-2">{{ find(feeTypes, { 'value': feeType.type }).name }}</span>
                    </div>
                  </td>
                  <td>
                    <a-form-item class="mb-0">
                      <div style="width:180px;">
                        <a-input-number
                          placeholder="Price"
                          v-decorator="[`fees[${feeType.id}][fee_amount]`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                          :initialValue="0"
                          :min="0"
                          :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                          style="width:100%;"
                        />
                      </div>
                    </a-form-item>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-3">
            <p class="mt-2 font-weight-bold">Fees Total:</p>
            <div class=" p-2 rounded-lg bg-light">
              <p class="mb-2 text-dark">
                One time: <span class="h5 font-weight-bold">{{ '₹ ' + getOnetimeFeeTotal().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
              </p>
              <p class="mb-0 text-dark">
                Recurring: <span class="h5 font-weight-bold">{{ '₹ ' + getRecurringFeeTotal().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
              </p>
            </div>
          </div>
        </div>

        <a-divider />
        <p class="pt-3">Assign Class Subjects</p>
        <div class="row mb-3">
          <div class="col px-2">
            <table class="table table-sm table-responsive-sm">
              <thead>
                <tr>
                  <th scope="col">Subjects</th>
                  <th scope="col">Group of</th>
                  <th scope="col">Elective of</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="subject in subjects" :key="subject.id">
                  <td>
                    <div class="neo_table_subject_form">
                      <a-form-item>
                        <a-checkbox v-decorator="[`class_subjects[${subject.id}][is_selected]`, {
                          valuePropName: 'checked',
                          initialValue: false,
                        }]"
                        >
                          {{ subject.name }}
                        </a-checkbox>
                      </a-form-item>
                      <a-form-item class="d-none">
                        <a-input
                          placeholder="Name"
                          v-decorator="[`class_subjects[${subject.id}][subject_id]`, {initialValue: subject.id}]"
                        />
                      </a-form-item>
                    </div>
                  </td>
                  <td>
                    <div class="neo_table_subject_form">
                      <a-form-item>
                        <a-select
                          v-decorator="[
                            `class_subjects[${subject.id}][group_subject_id]`,
                            {rules: [{ required: false, message: 'Please select a group subject' }], initialValue: undefined},
                          ]"
                          :disabled="form.getFieldValue(`class_subjects[${subject.id}][elective_subject_id]`) || !form.getFieldValue(`class_subjects[${subject.id}][is_selected]`) ? true: false"
                        >
                          <a-select-option :value="undefined">
                            <span class="text-bold">None</span>
                          </a-select-option>
                          <template v-for="subjectList in subjects">
                            <a-select-option :value="subjectList.id" :key="subjectList.id" v-if="subjectList.id !== subject.id">
                              <span class="text-bold">{{subjectList.name}}</span>
                            </a-select-option>
                          </template>
                        </a-select>
                      </a-form-item>
                    </div>
                  </td>
                  <td>
                    <div class="neo_table_subject_form">
                      <a-form-item>
                        <a-select
                          v-decorator="[
                            `class_subjects[${subject.id}][elective_subject_id]`,
                            {rules: [{ required: false, message: 'Please select an elective group' }], initialValue: undefined},
                          ]"
                          :disabled="form.getFieldValue(`class_subjects[${subject.id}][group_subject_id]`) || !form.getFieldValue(`class_subjects[${subject.id}][is_selected]`) ? true: false"
                        >
                          <a-select-option :value="undefined">
                            <span class="text-bold">None</span>
                          </a-select-option>
                          <template v-for="subjectList in subjects">
                            <a-select-option :value="subjectList.id" :key="subjectList.id" v-if="subjectList.id !== subject.id">
                              <span class="text-bold">{{subjectList.name}}</span>
                            </a-select-option>
                          </template>
                        </a-select>
                      </a-form-item>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <a-divider />
        <p class="pt-3">Internal Assessments</p>
        <div class="row mb-3 neo_internal_assessment">
            <div class="col-6" v-for="internalAssessment in internalAssessments" :key="internalAssessment.id">
              <a-form-item>
                <a-checkbox v-decorator="[`internal_assessments[${internalAssessment.id}][is_selected]`, {
                  valuePropName: 'checked',
                  initialValue: false,
                }]">
                  {{ internalAssessment.name }}
                </a-checkbox>
              </a-form-item>
              <a-form-item class="d-none">
                <a-input
                  placeholder="Name"
                  v-decorator="[`internal_assessments[${internalAssessment.id}][internal_assessment_id]`, {initialValue: internalAssessment.id}]"
                />
              </a-form-item>
            </div>
        </div>

        <a-divider />
        <p class="pt-3">Assign Class Sections
          <span class="float-right">
            <button class="btn btn-sm btn-primary" @click="handleSelectAllSections">
              Select All Sections
            </button>
          </span>
        </p>
        <div class="row mb-3">
          <div class="col-md-6" v-for="section in sections" :key="section.id">
            <div class="row align-items-center">
              <div class="col-md-4">
                <a-form-item>
                  <a-checkbox v-decorator="[`section_class_teachers[${section.id}][is_selected]`, {
                    valuePropName: 'checked',
                    initialValue: false,
                  }]"
                  @change="handleSectionSelect($event, section.id)"
                  >
                    {{ section.name }}
                  </a-checkbox>
                </a-form-item>
                <a-form-item class="d-none">
                  <a-input
                    placeholder="Name"
                    v-decorator="[`section_class_teachers[${section.id}][section_id]`, {initialValue: section.id}]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-8">
                <a-form-item class="d-none">
                  <a-input
                    v-decorator="[`section_class_teachers[${section.id}][teacher_id]`,]"
                  />
                </a-form-item>
                <a-button type="link" @click="showTeacherModal(section.id)" :disabled="form.getFieldValue(`section_class_teachers[${section.id}][is_selected]`) ? false: true">
                  <span :id="`teacher_${section.id}_name`" v-if="form.getFieldValue(`section_class_teachers[${section.id}][teacher_id]`)">
                    {{ getTeacherName(form.getFieldValue(`section_class_teachers[${section.id}][teacher_id]`)) }}
                  </span>
                  <span :id="`teacher_${section.id}_name`" v-else>
                    <button class="btn btn-sm btn-outline-primary" :class="!form.getFieldValue(`section_class_teachers[${section.id}][is_selected]`) ? 'disabled': ''">
                      Assign class teacher
                    </button>
                  </span>
                </a-button>
                <a-button type="link" v-if="form.getFieldValue(`section_class_teachers[${section.id}][teacher_id]`)" class="text-danger p-0 ml-3 mr-2" @click="removeTeacher(section.id)"><i class="fe fe-x-circle" /></a-button>

                <a-modal title="Teachers" v-model="teacherModalVisible" onOk="hideTeacherModal" onCancel="hideTeacherModal" :footer="null">
                  <div class="mb-3">
                    <a-input-search placeholder="Search teacher" style="width: 200px" @search="onSearch" @keyup="onSearchChange" />
                    <hr>
                  </div>
                  <a-spin :spinning="loadingTeacher">
                  <a-list itemLayout="horizontal" :dataSource="teachers">
                      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
                        <button class="btn btn-sm btn-outline-primary" slot="actions" @click="handleCTAssign(item)">Assign as class teacher</button>
                        <a-list-item-meta
                          :description="`${item.title}`"
                        >
                          <span slot="title">{{item.first_name}} {{item.last_name}}</span>
                          <a-avatar
                            slot="avatar"
                            :src="`${item.photo}`"
                          />
                        </a-list-item-meta>

                      </a-list-item>
                    </a-list>
                    <div class="text-right">
                      <a-pagination
                          showSizeChanger
                          @showSizeChange="onShowSizeChange"
                          :total="meta.total"
                          :pageSize.sync="pageSize"
                          v-model="current"
                          @change="onChange"
                        >
                      </a-pagination>
                    </div>
                  </a-spin>
                </a-modal>
              </div>
            </div>
          </div>
        </div>

        <a-divider />
        <div class="row justify-content-between py-3">
          <div class="col-md-4">
            <!-- <a-button key="clear" class="btn btn-light" @click="handleClear">Clear Form</a-button> -->
          </div>
          <div class="col-md-4 text-md-right">
            <a-button key="back" @click="handleCancel" class="mr-3">Cancel</a-button>
            <a-button key="submit" v-if="rolesetting.insertable" type="primary" :loading="loading" @click="handleSubmit">Save Setup</a-button>
          </div>
        </div>
      </a-spin>
    </a-form>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import { feeTypes } from '@/services/globaldata'
import { find, debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import { makeFieldsData } from '../fields'

export default {
  name: 'ClassSetup',
  mounted: function() {
    this.form = this.$form.createForm(this)
    this.$http.get('/api/fee')
      .then(({ data }) => {
        this.classFeeTypes = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/subject')
      .then(({ data }) => {
        this.subjects = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/internal_assessment')
      .then(({ data }) => {
        this.internalAssessments = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/section')
      .then(({ data }) => {
        this.sections = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/class')
      .then(({ data }) => {
        this.schoolClasses = data.data
        this.selectLoading = false
      })
      .catch(error => {
        console.log(error)
      })
  },
  props: {
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      loading: false,
      selectLoading: true,
      uploadDisabled: false,
      visible: false,
      teacherModalVisible: false,
      loadingTeacher: true,
      spinning: true,
      dateFormat: 'DD-MM-YYYY',
      feeTypes,
      classFeeTypes: [],
      subjects: [],
      internalAssessments: [],
      sections: [],
      schoolSessions: [],
      teachers: [],
      fileList: [],
      currentSectionId: undefined,
      current: 1,
      pageSize: 20,
      meta: {},
      schoolClasses: [],
      selectedClass: null,
      selectedSession: null,
      sessions: [],
      classSetupData: {},
      showForm: false,
    }
  },
  computed: {
    ...mapState(['settings']),
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function(val) {
      this.selectedSession = val.id
    },
  },
  created() {
    this.onSearchChange = debounce(this.onSearchChange, 500)
  },
  methods: {
    moment,
    find,
    onSessionSelect(value) {
      if (this.selectedClass) {
        this.selectedSession = value
        value ? this.showForm = true : this.showForm = false
        this.getSetupDetails()
      }
    },
    onClassSelect(value) {
      this.selectedClass = value
      value ? this.showForm = true : this.showForm = false
      this.getSetupDetails()
    },
    getSetupDetails() {
      if (!this.selectedSession) {
        this.selectedSession = this.currentSession.id
      }
      if (this.selectedClass) {
        this.spinning = true
        this.form.resetFields()
        this.$http.get(`/api/classsetup/${this.selectedClass}/${this.selectedSession}`)
          .then(({ data }) => {
            this.classSetupData = data.data
            const fieldsData = makeFieldsData(data.data)
            this.form.setFieldsValue(fieldsData)
            this.spinning = false
          })
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getOnetimeFeeTotal() {
      let feesSum = 0
      this.classFeeTypes.forEach(element => {
        if (element.type === 1) {
          let fee = this.form.getFieldValue(`fees[${element.id}][fee_amount]`) ? this.form.getFieldValue(`fees[${element.id}][fee_amount]`) : 0
          feesSum = feesSum + fee
        }
      })
      return feesSum
    },
    getRecurringFeeTotal() {
      let feesSum = 0
      this.classFeeTypes.forEach(element => {
        if (element.type !== 1) {
          let fee = this.form.getFieldValue(`fees[${element.id}][fee_amount]`) ? this.form.getFieldValue(`fees[${element.id}][fee_amount]`) : 0
          feesSum = feesSum + fee
        }
      })
      return feesSum
    },
    showTeacherModal(sectionId) {
      this.teacherModalVisible = true
      this.currentSectionId = sectionId
      this.getTeachers()
    },
    hideTeacherModal() {
      this.teacherModalVisible = false
      this.currentSectionId = undefined
    },
    getTeachers() {
      this.loadingTeacher = true
      this.$http.get('/api/teacher', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.teachers = data.data
        this.loadingTeacher = false
        this.meta = data.meta
      })
    },
    searchTeacher(value) {
      this.loadingTeacher = true
      this.$http.get('/api/teacher', {
        params: {
          search: value,
        },
      }).then(({ data }) => {
        this.teachers = data.data
        this.loadingTeacher = false
      })
    },
    onSearch(value) {
      this.searchTeacher(value)
    },
    onSearchChange(e) {
      this.searchTeacher(e.target.value)
    },
    handleSelectAllSections() {
      this.sections.forEach(section => {
        this.form.setFieldsValue({ [`section_class_teachers[${section.id}][is_selected]`]: true })
      })
    },
    handleSectionSelect(e, sectionId) {
      let form = this.form
      if (!e.target.value) {
        form.setFieldsValue({ [`section_class_teachers[${sectionId}][teacher_id]`]: undefined })
      }
    },
    getTeacherName (teacherId) {
      let classSectionTeacher = this.classSetupData.class_sections
      let teacher = {}
      if (classSectionTeacher) {
        teacher = find(classSectionTeacher, { 'teacher_id': teacherId })
        if (teacher) {
          return teacher.class_teacher.first_name + ' ' + teacher.class_teacher.last_name
        } else {
          teacher = find(this.teachers, { 'id': teacherId })
          if (teacher) {
            return teacher.first_name + ' ' + teacher.last_name
          }
        }
      }
    },
    handleCTAssign(teacher) {
      let form = this.form
      form.setFieldsValue({ [`section_class_teachers[${this.currentSectionId}][teacher_id]`]: teacher.id })
      this.teacherModalVisible = false
    },
    removeTeacher (sectionId) {
      let form = this.form
      this.$confirm({
        title: 'Are you sure?',
        content: `Click Yes to remove class teacher!`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          form.setFieldsValue({ [`section_class_teachers[${sectionId}][teacher_id]`]: undefined })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getTeachers()
    },
    onChange(current) {
      this.current = current
      this.getTeachers()
    },
    handleSubmit(e) {
      this.spining = true

      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // build up internal assessment data
          if (values['internal_assessments']) {
            values['internal_assessments'] = values['internal_assessments'].filter((value) => {
              return value.is_selected
            }).map((value) => {
              return value.internal_assessment_id
            })
          }

          // build up class subject data
          values['class_subjects'] = values['class_subjects'].filter((value) => {
            return value.is_selected
          }).map((value) => {
            // 0 - normal, 1- elective, 2- group
            let classSubjectType = 0
            let belongsToSubjectId = null

            if (value.group_subject_id) {
              classSubjectType = 2
              belongsToSubjectId = value.group_subject_id
            }
            if (value.elective_subject_id) {
              classSubjectType = 1
              belongsToSubjectId = value.elective_subject_id
            }
            return {
              subject_id: value.subject_id,
              belongs_to_subject_id: belongsToSubjectId,
              class_subject_type: classSubjectType,
            }
          })

          // build up section class teacher data
          values['section_class_teachers'] = values['section_class_teachers'].filter((value) => {
            return value.is_selected
          }).map((value) => {
            return {
              section_id: value.section_id,
              teacher_id: value.teacher_id,
            }
          })
          let fees = values['fees'].filter((value) => {
            console.log(value.fee_amount)
            return value.fee_amount !== undefined && value.fee_amount !== 0 && value.fee_amount !== null
          })
          values['fees'] = fees
          values['class_id'] = this.selectedClass
          values['session_id'] = this.selectedSession
          // console.log(values)
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to save the class setup.`,
            onOk: () => {
              this.$http
                .post('/api/classsetup', values)
                .then(({ data }) => {
                  this.$emit('created')
                  this.spining = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully saved!',
                    description: `Class setup details saved successfully.`,
                  })
                  this.getSetupDetails()
                })
                .catch(error => {
                  this.spining = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.spining = false
            },
          })
        }

        this.spining = false
      })
    },
    handleCancel(e) {
      this.showForm = false
      this.loading = false
      this.form.resetFields()
    },
  },
}
</script>

<style lang="scss">

.table th{
  margin-bottom: 0.7rem;
  vertical-align: middle;
}
.table td {
  padding: 0rem;
  vertical-align: middle;
}
.table, .neo_internal_assessment {
  .ant-form-item{
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0rem 0.5rem;
  }
}
.neo_table_subject_form{
  width: 200px;
}

</style>
